export default "__VITE_ASSET__CP_SAbgW__"